export const AUTO_RESUME_PENDING_STORAGE_PREFIX =
	'beelday_recording_auto_resume_pending'

const getSessionStorage = (): Storage | null => {
	if (typeof window === 'undefined') {
		return null
	}

	try {
		return window.sessionStorage
	} catch {
		return null
	}
}

export const getAutoResumePendingStorageKey = (
	workflowId: string,
	interactionSchemeId: string,
	userId: string
): string =>
	`${AUTO_RESUME_PENDING_STORAGE_PREFIX}:${workflowId}:${interactionSchemeId}:${userId}`

export const readAutoResumePending = (storageKey: string): boolean =>
	getSessionStorage()?.getItem(storageKey) === 'true'

export const writeAutoResumePending = (
	storageKey: string,
	pending: boolean
): void => {
	const storage = getSessionStorage()
	if (!storage) {
		return
	}

	if (pending) {
		storage.setItem(storageKey, 'true')
	} else {
		storage.removeItem(storageKey)
	}
}
